export interface ITaskTypeListItem {
    id: string;
    companyId: string;
    code: string;
    comment: string;
    activeState: number;
    usageAmount: number;
    unitIds: string[];
}

export class TaskTypeListItem implements ITaskTypeListItem {
    id: string;
    companyId: string;
    code: string;
    comment: string;
    activeState: number;
    usageAmount: number;
    unitIds: string[];

    constructor();
    constructor(obj: ITaskTypeListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.companyId = obj && obj.companyId || "";
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.activeState = obj && obj.activeState || 0;
        this.usageAmount = obj && obj.usageAmount || 0;
        this.unitIds = obj?.unitIds || [];
    }
}